<span class="summary-label">{{ label }}</span>

<strong class="summary-value">{{ value }}</strong>
